import { useRef, useState } from 'react'
import { useObserver } from '@fs/zion-frontend-friends'

export default function useInView<T>(): [React.RefObject<T>, boolean] {
  const ref = useRef<T>(null)
  const [inView, setInView] = useState(false)

  useObserver(
    ref as never,
    (entry) => {
      if (!inView && entry.isIntersecting) {
        setInView(true)
      }
    },
    () => {
      /* noop */
    }
  )

  return [ref, inView]
}
